import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from 'components/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import NoteIcon from '@mui/icons-material/Description';
import ShareIcon from '@mui/icons-material/Share';
import Dropdown from 'components/Dropdown';
import ShareModal from './ShareModal';
import PlayModal from './PlayModal';
import { getReactions } from '../utils';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import DataTable from 'components/DataTable';
import Button from 'components/Button';
import Action, { MODULES, ACTIONS } from 'components/Access';

const VideoTable = ({ data, onAction, loading, noDataMessage }) => {
  const [showShare, setShowShare] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);

  const toggleShareModal = (row) => setShowShare(row);
  const togglePlayer = (row) => setShowPlayer(row);

  const handleMenuClick = (row) => (action) => {
    return onAction(action, row);
  };

  const columns = [
    {
      dataField: 'headline',
      text: 'Page',
      formatter: (headline, row) => (
        <Box display="flex" alignItems="center" flex={1} flexWrap="wrap">
          <Avatar
            sx={{
              bgcolor: 'warning.lighter',
              border: '1px solid',
              borderColor: 'warning.light',
              borderRadius: 1,
            }}
          >
            <NoteIcon color="warning" />
          </Avatar>
          <Box ml={1}>
            <Box ml={0.5} mt={0.5}>
              <Typography component={Link} to={`/pages/edit/${row.hash}`}>
                {headline}
              </Typography>
              {/*<Typography color="textSecondary">by Tyler Smith</Typography>*/}
            </Box>
          </Box>
        </Box>
      ),
    },
    {
      dataField: 'visits',
      text: 'Views',
      align: 'right',
    },
    {
      dataField: 'plays',
      text: 'plays',
      align: 'right',
    },
    {
      dataField: 'clicks',
      text: 'Clicks',
      align: 'right',
    },
    {
      text: 'Reactions',
      formatter: (_, row) => {
        const reactions = getReactions(row).map((i) => (
          <Chip
            rounded
            variant="outlined"
            color="neutral"
            avatar={
              <Avatar sx={{ bgcolor: 'background.default', fontSize: 16 }}>
                {i.emoji}
              </Avatar>
            }
            label={i.count}
          />
        ));
        return (
          <Stack spacing={1} direction="row">
            {reactions}
          </Stack>
        );
      },
    },
    {
      align: 'right',
      formatter: (_, row) => {
        if (row.page_deleted === '1') return null;
        return (
          <IconButton
            onClick={() => toggleShareModal(row)}
            size="small"
            icon={<ShareIcon fontSize="small" />}
          />
        );
      },
    },
    {
      align: 'right',
      text: 'Actions',
      formatter: (_, row) => {
        const actions =
          row.favorite === '1'
            ? [
                {
                  key: 'edit',
                  children: 'Edit',
                  component: Link,
                  to: `/pages/edit/${row.hash}`,
                },
                { key: 'unfavorite', children: 'Unfavorite' },
                { key: 'delete', children: 'Delete' },
              ]
            : [
                {
                  key: 'edit',
                  children: 'Edit',
                  component: Link,
                  to: `/pages/edit/${row.hash}`,
                },
                { key: 'favorite', children: 'Favorite' },
                { key: 'delete', children: 'Delete' },
              ];

        if (row.page_deleted === '1') {
          return (
            <Button variant="text" onClick={() => onAction('restore', row)}>
              Restore
            </Button>
          );
        }
        return (
          <Action module={MODULES.VIDEO_NOTES} action={ACTIONS.MODIFY}>
            <Dropdown
              onSelect={handleMenuClick(row)}
              id="actions"
              options={actions}
            >
              <IconButton icon={<MoreHorizIcon />} size="large" />
            </Dropdown>
          </Action>
        );
      },
    },
  ];

  return (
    <Box p={2}>
      <DataTable
        key="hash"
        size="small"
        variant="card"
        loading={loading}
        data={data}
        columns={columns}
        emptyMessage={noDataMessage}
      />
      {showShare && (
        <ShareModal videoPage={showShare} onClose={() => toggleShareModal()} />
      )}
      {showPlayer && (
        <PlayModal video={showPlayer} onClose={() => togglePlayer()} />
      )}
    </Box>
  );
};

export default VideoTable;
